<span
  role="button"
  [attr.aria-label]="ariaLabel()"
  (click)="buttonClickedHandler($event)"
>
  @if (displayLabel(); as label) {
    {{ label }}
  } @else {
    <mat-icon class="ref-preview-doc-icon" aria-hidden="true">description</mat-icon>
  }
</span>
